import React from "react";
import Nav from "../components/Nav";
import { useNavContext } from "../context/NavContext";

const Terminos = () => {
  const { setSearchTerm, proximasAVencer, proximosEventos } = useNavContext();

  return (
    <>
      <Nav
        handleSearch={setSearchTerm}
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      <main className="legal-shell">
        <article className="legal-card">
          <div className="legal-body">
            {/* === TÉRMINOS Y CONDICIONES === */}
            <section id="objeto" className="legal-section">
              <h1 style={{textAlign: "center"}}>TÉRMINOS Y CONDICIONES DE USO</h1>
              <h2 className="legal-h2">1. Objeto</h2>
              <p>
                El presente documento tiene por objeto establecer los términos y
                condiciones bajo los cuales los usuarios podrán acceder y
                utilizar la plataforma web de NOVER SOLUTIONS MÉXICO (en
                adelante, “la Plataforma”), destinada a la gestión empresarial
                tipo ERP (Enterprise Resource Planning).
              </p>
              <p>
                Al acceder, registrarse o utilizar la Plataforma, el usuario
                acepta los presentes Términos y Condiciones, reconociendo que ha
                leído y comprendido su contenido. Si en algún momento el usuario
                no está de acuerdo con los mismos, podrá dejar de utilizar la
                Plataforma sin que ello genere obligación adicional.
              </p>
            </section>

            <section id="registro" className="legal-section">
              <h2 className="legal-h2">2. Registro y cuenta de usuario</h2>
              <p>
                Para acceder a las funcionalidades de la Plataforma, el usuario
                deberá registrarse proporcionando información veraz, completa y
                actualizada, incluyendo su nombre, apellido, correo electrónico
                y ubicación.
              </p>
              <p>
                El usuario es responsable de mantener la confidencialidad de sus
                credenciales de acceso y de toda actividad realizada desde su
                cuenta. NOVER SOLUTIONS MÉXICO no será responsable por el uso no
                autorizado de las credenciales del usuario ni por los daños o
                perjuicios derivados de dicho uso.
              </p>
            </section>

            <section id="servicios" className="legal-section">
              <h2 className="legal-h2">3. Servicios y planes de suscripción</h2>
              <p>
                La Plataforma ofrece distintos planes de uso bajo la modalidad
                de suscripción mensual, cuyo pago se realizará mediante los
                métodos habilitados por NOVER SOLUTIONS MÉXICO. El usuario se
                obliga a proporcionar información de pago válida y a mantenerla
                actualizada. Los cobros efectuados no serán reembolsables, salvo
                disposición expresa en contrario o en los casos previstos por la
                legislación aplicable.
              </p>
              <p>
                NOVER SOLUTIONS MÉXICO se reserva el derecho de modificar los
                precios, planes o características del servicio, informando
                oportunamente a los usuarios a través de los medios de
                comunicación disponibles en la Plataforma.
              </p>
            </section>

            <section id="uso-permitido" className="legal-section">
              <h2 className="legal-h2">4. Uso permitido</h2>
              <p>
                El usuario se compromete a utilizar la Plataforma de conformidad
                con la legislación vigente, la moral, las buenas costumbres y el
                orden público.
              </p>
              <p className="legal-h3">Queda estrictamente prohibido:</p>
              <ol className="legal-list">
                <li>
                  Utilizar la Plataforma con fines ilícitos, fraudulentos o
                  contrarios a los presentes Términos y Condiciones.
                </li>
                <li>
                  Reproducir, modificar, distribuir o transmitir total o
                  parcialmente el software, contenidos o materiales sin
                  autorización previa y por escrito.
                </li>
                <li>
                  Interferir, dañar, alterar o intentar acceder sin autorización
                  a los sistemas informáticos o a las cuentas de otros usuarios.
                </li>
              </ol>
              <p>
                NOVER SOLUTIONS MÉXICO podrá suspender o cancelar la cuenta de
                cualquier usuario que incumpla estas disposiciones, sin que ello
                genere derecho a reembolso alguno.
              </p>
            </section>

            <section id="propiedad" className="legal-section">
              <h2 className="legal-h2">5. Propiedad intelectual</h2>
              <p>
                Todos los derechos de propiedad intelectual e industrial sobre
                la Plataforma, su código fuente, logotipos, diseños, textos,
                gráficos y demás elementos son propiedad exclusiva de NOVER
                SOLUTIONS MÉXICO, o bien se encuentran debidamente licenciados a
                su favor. El acceso no implica cesión o concesión de derechos al
                usuario, limitándose este a un derecho de uso personal y no
                transferible.
              </p>
            </section>

            <section id="responsabilidad" className="legal-section">
              <h2 className="legal-h2">6. Responsabilidad</h2>
              <p>
                NOVER SOLUTIONS MÉXICO realiza esfuerzos razonables para
                mantener la Plataforma operativa y libre de errores; sin
                embargo, no garantiza su disponibilidad continua o la ausencia
                de interrupciones. En ningún caso será responsable por daños
                indirectos, incidentales o consecuenciales, incluyendo pérdida
                de información o lucro cesante derivados del uso o imposibilidad
                de uso.
              </p>
            </section>

            <section id="privacidad-ref" className="legal-section">
              <h2 className="legal-h2">7. Privacidad y protección de datos</h2>
              <p>
                El tratamiento de los datos personales recabados se regirá por
                la Política de Privacidad vigente de NOVER SOLUTIONS MÉXICO, la
                cual forma parte integral de estos Términos y Condiciones.
              </p>
            </section>

            <section id="modificaciones" className="legal-section">
              <h2 className="legal-h2">8. Modificaciones</h2>
              <p>
                NOVER SOLUTIONS MÉXICO se reserva el derecho de modificar, en
                cualquier momento y sin previo aviso, el contenido de estos
                Términos y Condiciones. Las modificaciones regirán desde su
                publicación; el uso continuado implica aceptación.
              </p>
            </section>

            <section id="ley" className="legal-section">
              <h2 className="legal-h2">
                9. Legislación aplicable y jurisdicción
              </h2>
              <p>
                Se rigen por las leyes de los Estados Unidos Mexicanos. Para su
                interpretación y cumplimiento, las partes se someten a los
                tribunales competentes de la Ciudad de México.
              </p>
            </section>

            <section id="contacto" className="legal-section">
              <h2 className="legal-h2">10. Contacto</h2>
              <p className="legal-contact">
                📧 <a href="mailto:contacto@nover.mx">contacto@nover.mx</a>
              </p>
            </section>

            {/* === POLÍTICA DE PRIVACIDAD === */}
            <section id="pp-header" className="legal-section">
              <h1 style={{textAlign: "center"}}>POLÍTICA DE PRIVACIDAD</h1>
              <p className="legal-meta">
                Última actualización: 13 de octubre de 2025 &middot; Razón
                social: NOVER SOLUTIONS MÉXICO &middot; Domicilio: México
                &middot; Contacto:{" "}
                <a href="mailto:privacidad@nover.mx">privacidad@nover.mx</a>
              </p>
            </section>

            <section id="identidad" className="legal-section">
              <h3 className="legal-h3">
                1. Identidad y domicilio del responsable
              </h3>
              <p>
                NOVER SOLUTIONS MÉXICO (el “Responsable”) es responsable del
                tratamiento de los datos personales recabados de los usuarios
                (“Titular”) a través de la plataforma NOVER ERP (“la
                Plataforma”), conforme a la LFPDPPP.
              </p>
            </section>

            <section id="datos" className="legal-section">
              <h3 className="legal-h3">2. Datos personales recabados</h3>
              <ul className="legal-list">
                <li>Nombre y apellido</li>
                <li>Correo electrónico</li>
                <li>Ubicación geográfica</li>
                <li>Datos de facturación y método de pago</li>
                <li>Información técnica por cookies y tecnologías similares</li>
              </ul>
              <p>No se recaban datos personales sensibles conforme a la Ley.</p>
            </section>

            <section id="finalidades" className="legal-section">
              <h3 className="legal-h3">3. Finalidades del tratamiento</h3>
              <p className="legal-h3">Primarias:</p>
              <ol className="legal-list">
                <li>Crear, administrar y mantener la cuenta del usuario.</li>
                <li>Procesar pagos, facturación y suscripciones.</li>
                <li>
                  Proveer soporte técnico, actualizaciones y mantenimiento.
                </li>
              </ol>
              <p className="legal-h3" style={{ marginTop: 10 }}>
                Secundarias:
              </p>
              <ol className="legal-list">
                <li>
                  Análisis estadístico y de seguridad para mejora del servicio.
                </li>
                <li>
                  Envío de avisos y comunicaciones (el Titular puede oponerse).
                </li>
              </ol>
              <p>
                Para oponerse a finalidades secundarias, escribe a{" "}
                <a href="mailto:privacidad@nover.mx">privacidad@nover.mx</a>.
              </p>
            </section>

            <section id="cookies" className="legal-section">
              <h3 className="legal-h3">4. Uso de cookies y tecnologías</h3>
              <p>
                Utilizamos cookies para mejorar la experiencia, analizar tráfico
                y optimizar rendimiento. Puedes deshabilitarlas en tu navegador;
                algunas funciones podrían limitarse.
              </p>
            </section>

            <section id="transferencias" className="legal-section">
              <h3 className="legal-h3">5. Transferencia de datos</h3>
              <ol className="legal-list">
                <li>
                  A proveedores que dan soporte a la operación (hosting, pagos,
                  mensajería, analítica).
                </li>
                <li>Cuando lo exija la ley o autoridad competente.</li>
              </ol>
              <p>
                Los terceros asumen obligaciones de confidencialidad
                equivalentes.
              </p>
            </section>

            <section id="seguridad" className="legal-section">
              <h3 className="legal-h3">6. Medidas de seguridad</h3>
              <p>
                Aplicamos medidas administrativas, técnicas y físicas para
                proteger datos contra daño, pérdida, alteración o acceso no
                autorizado. Ningún sistema es 100% seguro; usar la Plataforma
                implica aceptar riesgos inherentes.
              </p>
            </section>

            <section id="arco" className="legal-section">
              <h3 className="legal-h3">7. Derechos ARCO</h3>
              <p>
                Para ejercer Acceso, Rectificación, Cancelación u Oposición,
                envía solicitud a{" "}
                <a href="mailto:privacidad@nover.mx">privacidad@nover.mx</a>{" "}
                con:
              </p>
              <ul className="legal-list">
                <li>Nombre completo.</li>
                <li>Descripción de los datos y derecho a ejercer.</li>
                <li>Documentos que acrediten identidad o representación.</li>
              </ul>
              <p>
                Responderemos en un máximo de 20 días hábiles conforme al art.
                29 de la LFPDPPP.
              </p>
            </section>

            <section id="conservacion" className="legal-section">
              <h3 className="legal-h3">8. Conservación</h3>
              <p>
                Conservamos datos por el tiempo necesario para cumplir
                finalidades y requerimientos legales/fiscales/contractuales.
                Posteriormente serán eliminados o anonimizados de forma segura.
              </p>
            </section>

            <section id="cambios-pp" className="legal-section">
              <h3 className="legal-h3">9. Modificaciones a la Política</h3>
              <p>
                Podremos actualizar esta Política para atender cambios
                legislativos o de práctica. Publicaremos la fecha de última
                actualización. El uso continuado se considera aceptación.
              </p>
            </section>

            <section id="consentimiento" className="legal-section">
              <h3 className="legal-h3">10. Consentimiento del Titular</h3>
              <p>
                El Titular declara haber leído y comprendido esta Política y
                otorga su consentimiento para el tratamiento de sus datos
                personales conforme a lo aquí establecido.
              </p>
            </section>
          </div>
        </article>
      </main>
    </>
  );
};

export default Terminos;
